import { Injectable } from '@angular/core';
import { BinaryWriter } from 'google-protobuf';
import { CustomizedMenu } from '../../../libs/proto/commUnity_pb';

@Injectable({
  providedIn: 'root'
})
export class CustomizedMenusConversionService {

  constructor() { }

  ToStorage(req: CustomizedMenu) {
    const w = new BinaryWriter();
    CustomizedMenu.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  FromStorage(data: any, callback: (CustomizedMenu: CustomizedMenu, errorConvert: any) => void) {
    try {
      callback( CustomizedMenu.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }

  ToStorages(menus: CustomizedMenu[]) {
    const rets = new Array<Uint8Array | number[]>();

    menus.forEach(element => {
      rets.push(
        this.ToStorage(element)
      );
    });

    return {data: rets};
  }

  FromStorages(data: any, callback: (CustomizedMenu: CustomizedMenu[], errorConvert: any) => void) {
    if (data == null) {
      callback(null, Error('empty'));
      return;
    }
    const emps = new Array<CustomizedMenu>();
    const empjs: {data: (Uint8Array)[]} = data;
    try {

      empjs.data.forEach(element => {
        const emp = CustomizedMenu.deserializeBinary( element  );
        emps.push ( emp );
      });

      callback( emps, null);
    } catch (error) {
      callback( null, error);
    }
  }
}
